import { action } from 'satcheljs';

/**
 * Action to trigger reload of calendar surface
 */
export const reloadCalendarSurface = action('reloadCalendarSurface');
